import { ReactNode } from 'react';
import { lt } from '@mews/framework';
import { Icon, IconName } from '@optimus-web/core';
import { getDataTestIdForPaymentType, ProcessPaymentType } from '../ProcessPaymentType';

interface ProcessPaymentTypeCardGroup {
    value: ProcessPaymentType;
    name: ProcessPaymentType;
    label: ReactNode;
    description: ReactNode;
    media: ReactNode;
    dataTestId: string;
}

export const processPaymentTypeCardGroupMap: Record<ProcessPaymentType, ProcessPaymentTypeCardGroup> = {
    [ProcessPaymentType.GatewayPayment]: {
        value: ProcessPaymentType.GatewayPayment,
        name: ProcessPaymentType.GatewayPayment,
        label: lt('ProcessPaymentMewsPaymentsCardPaymentTitle'),
        description: lt('ProcessPaymentMewsPaymentsCardPaymentOptionDescription'),
        media: <Icon value={IconName.PaymentCard} />,
        dataTestId: getDataTestIdForPaymentType(ProcessPaymentType.GatewayPayment),
    },
    [ProcessPaymentType.MewsTerminalPayment]: {
        value: ProcessPaymentType.MewsTerminalPayment,
        name: ProcessPaymentType.MewsTerminalPayment,
        label: lt('Terminal'),
        description: lt('ProcessPaymentMewsPaymentsMewsTerminalPaymentOptionDescription'),
        media: <Icon value={IconName.Terminal} />,
        dataTestId: getDataTestIdForPaymentType(ProcessPaymentType.MewsTerminalPayment),
    },
    [ProcessPaymentType.PaymentRequest]: {
        value: ProcessPaymentType.PaymentRequest,
        name: ProcessPaymentType.PaymentRequest,
        label: lt('PaymentRequest'),
        description: lt('ProcessPaymentMewsPaymentsPaymentLinkOptionDescription'),
        media: <Icon value={IconName.PaymentRequest} />,
        dataTestId: getDataTestIdForPaymentType(ProcessPaymentType.PaymentRequest),
    },
    [ProcessPaymentType.ExternalCardPayment]: {
        value: ProcessPaymentType.ExternalCardPayment,
        name: ProcessPaymentType.ExternalCardPayment,
        label: lt('ProcessPaymentExternalPaymentsCardPaymentTitle'),
        description: lt('ProcessPaymentExternalPaymentsCardPaymentOptionDescription'),
        media: <Icon value={IconName.PaymentCard} />,
        dataTestId: getDataTestIdForPaymentType(ProcessPaymentType.ExternalCardPayment),
    },
    [ProcessPaymentType.CashPayment]: {
        value: ProcessPaymentType.CashPayment,
        name: ProcessPaymentType.CashPayment,
        label: lt('CashPayment'),
        description: lt('ProcessPaymentExternalPaymentsCashPaymentOptionDescription'),
        media: <Icon value={IconName.CashPayment} />,
        dataTestId: getDataTestIdForPaymentType(ProcessPaymentType.CashPayment),
    },
    [ProcessPaymentType.ExternalPayment]: {
        value: ProcessPaymentType.ExternalPayment,
        name: ProcessPaymentType.ExternalPayment,
        label: lt('ExternalPayment'),
        description: lt('ProcessPaymentExternalPaymentsOtherPaymentOptionDescription'),
        media: <Icon value={IconName.ExternalPayment} />,
        dataTestId: getDataTestIdForPaymentType(ProcessPaymentType.ExternalPayment),
    },
    [ProcessPaymentType.TokenizeCard]: {
        value: ProcessPaymentType.TokenizeCard,
        name: ProcessPaymentType.TokenizeCard,
        label: lt('ProcessPaymentMewsPaymentsTokenizeCardTitle'),
        description: lt('ProcessPaymentMewsPaymentsTokenizeCardOptionDescription'),
        media: <Icon value={IconName.PaymentCard} />,
        dataTestId: getDataTestIdForPaymentType(ProcessPaymentType.TokenizeCard),
    },
    [ProcessPaymentType.RecordCard]: {
        value: ProcessPaymentType.RecordCard,
        name: ProcessPaymentType.RecordCard,
        label: lt('ProcessPaymentMewsPaymentsRecordCardTitle'),
        description: lt('ProcessPaymentMewsPaymentsRecordCardOptionDescription'),
        media: <Icon value={IconName.PaymentCard} />,
        dataTestId: getDataTestIdForPaymentType(ProcessPaymentType.RecordCard),
    },
    [ProcessPaymentType.GatewayCardPreauth]: {
        value: ProcessPaymentType.GatewayCardPreauth,
        name: ProcessPaymentType.GatewayCardPreauth,
        label: lt('ProcessPaymentMewsPaymentsGatewayPreauthorizationTitle'),
        description: lt('ProcessPaymentMewsPaymentsGatewayPreauthorizationOptionDescription'),
        media: <Icon value={IconName.PaymentCard} />,
        dataTestId: getDataTestIdForPaymentType(ProcessPaymentType.GatewayCardPreauth),
    },
    [ProcessPaymentType.ExternalCardPreauth]: {
        value: ProcessPaymentType.ExternalCardPreauth,
        name: ProcessPaymentType.ExternalCardPreauth,
        label: lt('ProcessPaymentMewsPaymentsExternalPreauthorizationTitle'),
        description: lt('ProcessPaymentMewsPaymentsExternalPreauthorizationOptionDescription'),
        media: <Icon value={IconName.PaymentCard} />,
        dataTestId: getDataTestIdForPaymentType(ProcessPaymentType.ExternalCardPreauth),
    },
    [ProcessPaymentType.MewsTerminalPreauth]: {
        value: ProcessPaymentType.MewsTerminalPreauth,
        name: ProcessPaymentType.MewsTerminalPreauth,
        label: lt('ProcessPaymentMewsPaymentsMewsTerminalPreauthorizationTitle'),
        description: lt('ProcessPaymentMewsPaymentsMewsTerminalPreauthorizationOptionDescription'),
        media: <Icon value={IconName.Terminal} />,
        dataTestId: getDataTestIdForPaymentType(ProcessPaymentType.MewsTerminalPreauth),
    },
};
